export const Offices = () => import("./Offices.vue");
export const OfficeFolders = () => import("./OfficeFolders.vue");
